import { ProductType } from '@/data/types/Product';
import {
	EVENT_SEARCH_SUBMITTED_TERM_KEY,
	buildSearchPayload,
} from 'presentation/events/hooks/useTrackSearchSubmit';
import { useTrackSearchSubmitGA4 } from 'presentation/events/hooks/useTrackSearchSubmit/useTrackSearchSubmitGA4';
import { useEffect } from 'react';

interface TrackSearchResultsProps {
	products: ProductType[];
	searchTerm: string | string[] | undefined;
	loading: boolean;
	pdpRedirectUrl?: string | null;
	isNullSearch?: boolean;
}

export const useTrackSearchResults = ({
	products,
	searchTerm,
	loading,
	pdpRedirectUrl,
	isNullSearch,
}: TrackSearchResultsProps) => {
	const { sendGA4Event } = useTrackSearchSubmitGA4();

	useEffect(() => {
		if (!searchTerm || loading || !products) return;

		const submittedTerm = sessionStorage.getItem(EVENT_SEARCH_SUBMITTED_TERM_KEY);
		if (!submittedTerm) return;
		sessionStorage.removeItem(EVENT_SEARCH_SUBMITTED_TERM_KEY);

		const term = submittedTerm.trim();
		if (!term) return;

		sendGA4Event(buildSearchPayload({ term, products, pdpRedirectUrl, isNullSearch }));
	}, [products, searchTerm, loading, pdpRedirectUrl, isNullSearch, sendGA4Event]);
};
